import { createId } from "./createId";

/**
 * 新しい assignmentId を生成する（{@link createId} の生成担当用エイリアス）。
 * 呼び出し側の意図を明示するために用意する。
 */
export function createAssignmentId(): string {
    return createId();
}
